<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normalsuoRiskScan dialog_normalsuo"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <div class="flex_center margin-bottom20">
          <img
            style="width: 58px"
            src="@/assets/dialogIcoImg/RiskScan.png"
            alt=""
          />
        </div>
        <h3>Risk Scan</h3>

        <div class="detail_cont_text" style="padding: 0px">
          <span class="font_bold"> Risk Scan </span> is your all-in-one platform
          for comprehensive corporate risk intelligence. We provide detailed
          analysis across every major risk category to safeguard your business
          decisions.
          <br />
          <ul class="ulyuan margin-bottom20 margin-top20">
            <li>
              <span class="font_bold"> Legal Risk: </span> Verify company's
              legitimacy
            </li>
            <li>
              <span class="font_bold">Organizational Risk: </span> Management
              stability, corporate structure complexity, and ownership
              transparency.
            </li>
            <li>
              <span class="font_bold"> Operational Risk: </span> Supply chain
              vulnerabilities, operational status, and geopolitical exposure.
            </li>
            <li>
              <span class="font_bold">Financial Performance Risk: </span>
              Profitability trends, liquidity issues, and balance sheet health.
            </li>
            <li>
              <span class="font_bold"> Credit Risk: </span> Creditworthiness,
              payment history, and probability of default.
            </li>
            <li>
              <span class="font_bold">Compliance Risk: </span> Adherence to
              sanctions, AML regulations, and industry-specific laws.
            </li>
            <li>
              <span class="font_bold"> Sustainability Risk:</span> ESG
              (Environmental, Social, Governance) factors and reputational
              impacts.
            </li>
            <li>
              <span class="font_bold"> Industry Risk: </span> Assesses the
              stability and outlook of a company's entire sector.
            </li>
          </ul>
          Upload your list of companies, and Risk Scan will provide you with
          instant data updates for each entity. With comprehensive risk
          assessments across eight risk categories, Risk Scan transforms your
          risk management from reactive to a proactive strategic advantage.
        </div>
        <div
          class="flex_center_between_box phoen_center_flex_warp"
          style="justify-content: center !important; margin-top: 20px"
        >
          <el-button
            class="btn_export"
            @click="LetsBegin()"
            style="min-height: 40px !important"
          >
            Let's Begin</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 点击阅读同意弹出 -->
    <el-dialog
      :visible.sync="newDialogtwo"
      center
      :close-on-click-modal="true"
      custom-class="dialog_normal"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <div class="flex_center">
          <img
            style="width: 60px"
            src="@/assets/dialogIcoImg/RiskScantwo.png"
            alt=""
          />
        </div>
        <ul class="detail_cont_text">
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >1.&nbsp; Add companies from Search Result</span
              >
              <button
                class="btn_export"
                style="min-height: 40px !important"
                @click="goHome('/')"
              >
                Choose
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >2.&nbsp;Add companies from My Database</span
              >
              <button
                class="btn_export"
                @click="gotoUSer('/account/companiesViewed')"
                style="min-height: 40px !important"
              >
                Choose
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >3.&nbsp;Add companies by upload my own list</span
              >
              <button
                class="btn_export"
                @click="UploadFileList()"
                style="min-height: 40px !important"
              >
                Upload
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title">4.&nbsp;Updated data</span>
              <button
                :class="
                  updateDowinList.length == 0
                    ? 'btn_exporthui'
                    : 'btn_export btnbox'
                "
                class="btn_export"
                :disabled="updateDowinList.length == 0"
                style="min-height: 40px !important"
                @click="goHome('/index/riskScan?Update=true')"
              >
                View
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
        </ul>
      </div>
    </el-dialog>

    <UpdateFile
      :UpdateFileDialog="UpdateFileDialog"
      :isUploaded="isUploaded"
      @closeUpDownDialog="closeUpDownDia"
    >
    </UpdateFile>
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <PermissionDialog></PermissionDialog>
  </div>
</template>
<script>
import crypto from "@/utils/crypto";
import Login from "../login.vue";
import bus from "../bus";
import PermissionDialog from "@/components/power/PermissionDialog.vue";

import { getTabListOneLayerForAccount } from "@/api/companyApi";
import { getUserConsumptionPage } from "@/api/userApi";

import UpdateFile from "../../views/myAccount/Database/adCppany/UpdateFile.vue";
export default {
  components: {
    UpdateFile,
    Login,
    PermissionDialog,
  },
  props: {
    showReport: {
      type: Boolean,
      default: false,
    },
    powerStatus: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    newDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getTabListOneLayerForAccountlist();
        }

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      // newDialog: true,
      loginDialog: false,
      powerArr: [],
      token: localStorage.getItem("token"),
      isUploaded: false,
      finDialog: false,
      reportDialog: false,
      newDialogtwo: false,
      UpdateFileDialog: false,
      updateDowinList: [],
      filesList: [],
      disabledReport1: true,
      disabledReport2: true,
      disabledReport: true,
      checked: false,
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.showReport;
      },
      set(newValue) {},
    },
  },
  created() {
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    bus.$on("handleLogin", (loginCheck) => {
      // location.reload();
      this.loginStatus = loginCheck;
      this.getTabListOneLayerForAccountlist();
    });
  },
  methods: {
    getgetUserConsumptionPageList(value) {
      getUserConsumptionPage({
        page: 1,
        pageSize: 100,
        statusList: [1],
      }).then((res) => {
        if (res.code == 200 && res.data.rows.length > 0) {
          let aadis = res.data.rows.map((item) => item.companyAaaid);
          this.updateDowinList = aadis;
        } else {
          this.updateDowinList = [];
        }
      });
    },
    getTabListOneLayerForAccountlist() {
      getTabListOneLayerForAccount({
        moduleId: 507,
      }).then((res) => {
        if (res.code == 200) {
          this.powerArr = res.data;
        }
      });
    },
    LetsBegin() {
      if (this.loginStatus) {
        this.newDialogtwo = true;
        this.loginDialog = false;
        this.getgetUserConsumptionPageList();
      } else {
        this.loginDialog = true;
        this.newDialogtwo = false;
      }
    },
    UploadFileList() {
      if (this.powerArr[5].hasPrivilege) {
        this.UpdateFileDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // 上传弹框
    closeUpDownDia(val) {
      this.UpdateFileDialog = val;
    },
    // 渠道个人中心
    gotoUSer(value) {
      this.$router
        .push({
          path: value,
          query: {
            type: 1,
          },
        })
        .then(() => {
          this.$router.go(0); // 等待页面路径更新后再刷新页面
        });
    },
    goHome(value) {
      //  if( this.powerArr[1].hasPrivilege){
      this.$parent.newDialog = false;
      this.$router.push(value).then(() => {
        this.$router.go(0); // 等待页面路径更新后再刷新页面
      });

      //    }else{
      //  this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');
      //    }
    },
    //关闭弹窗
    closeDialog() {
      this.$emit("closeReportDialog", false);
    },

    //提交update
    onSubmit() {
      if (!this.powerStatus) {
        this.newDialog = false;
        this.finDialog = false;
      } else {
        this.newDialog = false;
        this.finDialog = false;
      }
    },
    //取消update
    cancel() {
      this.finDialog = false;
    },

    //取消report
    cancelReport() {
      this.reportDialog = false;
    },
    //添加report表单

    //删除report表单
    delForReport(n) {
      this.addReportList.splice(n, 1);
    },
  },
};
</script>
<style scoped>
.btn_box {
  text-align: center;
  margin-top: 1.7142857142857142rem;
}

.btn_cancel {
  background: #8497ab;
  border-radius: 0.7142857142857143rem;
  color: #ffffff;
  height: auto;
}

.btn_export {
  border-radius: 0.7142857142857143rem;
  height: auto;
}

.btn_box button + button {
  margin-left: 2.857142857142857rem;
}

.rep_list {
  padding-bottom: 0.7142857142857143rem;
}

.dialog_lg.el-dialog {
  width: 1150px;
  /* max-height: 85vh; */
  background: #ffffff;
}

.detail_cont_text {
  /* 解决英文截断问题 */
  word-break: keep-all;
  text-align: justify;
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 30px;
  padding-top: 20px;
}

.dialog_detail_title {
  font-size: 20px;
  color: #1a2332;
  /* line-height: 27px; */
  /* line-height: 40px; */
  margin-bottom: 20px;
  font-family: "Arial Bold";
}

.risk-li {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 1.4285714285714286rem;
}

.risk-li-title {
  font-size: 1.42857143rem;
  color: #1a2332;

  font-family: "Arial Bold";
}
</style>
